import { request } from '@/utils/request';
import { notification } from 'antd';
import clientSocket from '@/services/clientSocket';

type PreAuditItem = {rowId: number; content: string; isPreAudit?: boolean; verifiedStatus?: string;};

type GenerateAnswerItem = { rowId: number; answer: string; thinking: string; prompt: string; };


/** @description 任务结果控制 */
class PubSub {
  // 用于存储订阅者的回调函数
  private jobSubscribers: Map<string, Function> = new Map();
  private jobResultSubscribers: Map<number, Function> = new Map();
  private listCallbackFn: Function | null = null;

  constructor() {
    clientSocket.initTask(this, this.getJobResult);
  }

  public setListCallback(callback: Function) {
    this.listCallbackFn = callback;
  }

  // 发布消息的函数
  public async publish(results: PreAuditItem[], time: string, jobCategory: string) {
    for (const vo of results) {
      if (this.jobResultSubscribers.has(vo.rowId)) {
        this.jobResultSubscribers.get(vo.rowId)?.({
          content: `${vo.content}——${time}`,
          type: jobCategory === 'ANSWER_PREDICT' ? 'prediction' : 'preAudit',
          isPreAudit: Boolean(vo?.isPreAudit),
        });
      }
    }
    if (jobCategory === 'PRODUCT_QA_PRE_AUDIT') {
      this.updateTableData(results.map(r => ({
        from: r.rowId,
        to: {
          ...r,
          id: r.rowId,
          preAuditComment: r.content,
        }
      })))
    }
  };

  private updateTableData(value: any[]) {
    if (!this.listCallbackFn) return;
    this.listCallbackFn({
      type: 'update',
      value
    });
  }

  private notify (message: string, description: string) {
    notification.success({
      duration: null,
      message,
      description,
    });
  }

  private async getJobResult (jobId: string) {
    const { resp } = await request("/local/job/search", {
      method: "POST",
      data: {
        ids: [jobId],
      }
    });
    const list: { id: string; status: string; callback: any; updatedAt: string; name: string; category: string }[] = resp?.data?.list;
    list.forEach((job) => {
      if (["ANSWER_PREDICT", "PRODUCT_QA_PRE_AUDIT"].includes(job.category)) {
        this.publish(job.callback.results, job.updatedAt, job.category);
      }
      if (["ANSWER_GENERATE"].includes(job.category)) {
        this.updateTableData(job.callback.results.map((r: GenerateAnswerItem) => ({
          from: r.rowId,
          to: {
            ...r,
            id: r.rowId,
            answer: r.answer,
            thinking: r.thinking,
            prompt: r.prompt,
          }
        })))
      }
      
      const message = ["ANSWER_PREDICT", "PRODUCT_QA_PRE_AUDIT", "ANSWER_GENERATE"].includes(job.category) ? "请在相应的问题下查看结果！" : "刷新页面后可以看到！";
      this.notify(`${job.name}任务已完成`, message);
    })
  }

  // 订阅JOB消息的函数
  public subscribeJob(jobId: string, callback: Function) {
    this.jobSubscribers.set(jobId, callback);
  };

  public subscribeJobResult(rowId: number, callback: Function) {
    this.jobResultSubscribers.set(rowId, callback);
  }

  public clear() {
    this.jobResultSubscribers.clear();
    this.jobSubscribers.clear();
    this.listCallbackFn = null;
  }
};

export default new PubSub();